export default {
    namespaced: true,
    state: () => ({
        order: 'orderBy[name]=ASC'
    })
};
